export default "__VITE_ASSET__b95ae46c__"